enum Modal {
  VENDOR_CATALOG_UNMAPPED_ITEMS = 'vendorCatalogUnmappedItems',
  INVOICE_ITEMS_NEXT_STEP = 'invoiceItemsNextStep',
  INVOICE_OCR_STEP_1 = 'invoiceOcrStep1',
  INVOICE_OCR_STEP_2 = 'invoiceOcrStep2',
  INVOICE_OCR_STEP_3 = 'invoiceOcrStep3',
}

export default Modal;
